import CloseIcon from '@mui/icons-material/Close';
import ErrorIcon from '@mui/icons-material/Error';
import { useState } from 'react';
import Modal from 'react-modal';
import { IUpdateSolicitationInputModel } from 'inputModels';
import { Controller, useForm } from 'react-hook-form';
import { serialize } from 'object-to-formdata';
import { useSolicitation } from '../../../context/solicitation';
import { ContentModal, Header } from './styles';
import { SolicitationCancelationStatus, ServiceStatus } from '../../../types/enums';
import { SolicitationController } from '../../../controller/SolicitationController';
import { ReactComponent as IconError } from '../../../assets/icons/IconCancelCircle.svg';
import { Button } from '../../Buttons/Button';
import { DropDownList } from '../../DropDownList';
import { CANCELATION_REASON_DESCRIPTIONS } from '../../../constants';

interface ModalCancelSolicitationProps {
  isOpen: boolean;
  onRequestClose: () => void;
  solicitationId: string;
}
export function ModalCancelSolicitation({
  isOpen,
  solicitationId,
  onRequestClose,
}: ModalCancelSolicitationProps) {
  const { setSolicitations } = useSolicitation();
  const [showError, setShowError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [cancelationStatus, setCancelationStatus] = useState<string>();
  const [defaultValues] = useState({
    details: '',
  });
  const { control, watch, reset } = useForm({
    reValidateMode: 'onChange',
    defaultValues,
  });
  const cancelationDetails = watch('details');

  const handleRequestClose = () => {
    setShowError(false);
    setCancelationStatus(undefined);
    onRequestClose();
    reset();
  };
  const handleChange = (status: string) => {
    setCancelationStatus(status);
    setShowError(false);
  };
  const handleCancelSolicitation = () => {
    if (!cancelationStatus) {
      setShowError(true);
      return;
    }
    setIsLoading(true);
    setShowError(false);
    const update: IUpdateSolicitationInputModel = {
      solicitationId,
      status: ServiceStatus.CANCELED,
      cancelationStatus: Number(cancelationStatus) as unknown as SolicitationCancelationStatus,
      cancelationDetails,
    };
    const formData = serialize(update, { indices: true });

    SolicitationController.updateStatus(formData)
      .then(() => {
        setSolicitations((prev) => {
          const idxSolicitation = prev.findIndex((d) => d.id === solicitationId);
          const newSolicitations = [...prev];
          if (idxSolicitation !== -1) {
            newSolicitations[idxSolicitation].status = ServiceStatus.CANCELED;
            newSolicitations[idxSolicitation].cancelationDetails = cancelationDetails;
            newSolicitations[idxSolicitation].cancelationStatus = Number(
              cancelationStatus,
            ) as unknown as SolicitationCancelationStatus;
            newSolicitations[idxSolicitation].disabledAt = new Date();
          }
          return newSolicitations;
        });
      })
      .finally(() => {
        setIsLoading(false);
        handleRequestClose();
      });
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={handleRequestClose}
      overlayClassName="react-modal-overlay"
      className="react-cancel-solicitation-modal-content">
      <Header>
        <h1>
          <IconError /> Cancelar Solicitação
        </h1>
        <div className="close-div">
          <button type="button" onClick={handleRequestClose}>
            <CloseIcon fontSize="small" />
          </button>
        </div>
      </Header>
      <ContentModal>
        <div className="containerAttachment">
          <div className="contentAttachment">
            <DropDownList
              itens={
                CANCELATION_REASON_DESCRIPTIONS.map((c) => ({
                  id: c.id.toString(),
                  value: c.value,
                })) ?? []
              }
              typeReturn="id"
              placeholderTitle="Selecione o motivo"
              onChange={(s) => handleChange(s.toString())}
            />
          </div>
          {showError && (
            <p className="error">
              <ErrorIcon />
              Selecione um motivo para cancelar a solicitação
            </p>
          )}
        </div>
        <Controller
          control={control}
          name="details"
          render={({ field: { value, onChange, ...rest } }) => (
            <textarea
              value={value}
              onChange={onChange}
              {...rest}
              className="note"
              placeholder="Adicione suas observações"
            />
          )}
        />
        <div className="content-buttons">
          <Button
            text="Cancelar"
            dimensions={{ width: '12rem', height: '2rem' }}
            font={{ size: '14' }}
            color="background_white"
            background="primary"
            backgroundHoverColor="tertiary_500"
            textHoverColor="background_white"
            onClick={isLoading ? () => {} : handleRequestClose}
          />

          <Button
            text="Confirmar"
            loading={isLoading}
            dimensions={{ width: '12rem', height: '2rem' }}
            font={{ size: '14' }}
            color="background_white"
            background="secondary"
            backgroundHoverColor="tertiary_500"
            textHoverColor="background_white"
            border={{ color: 'primary' }}
            onClick={handleCancelSolicitation}
          />
        </div>
      </ContentModal>
    </Modal>
  );
}
